import './keyword_view.js.coffee';# Added by Script 
class Monitoring.Views.SortableKeywordView extends Monitoring.Views.KeywordView
  id: 'sortable-keywords'

  render: ->
    super
    @$el.find('.added').sortable
      axis: 'y'
      cursor: 'move'
      placeholder: 'sortable-keywords-placeholder'
      update: @updateOrder
    @

  addKeyword: (text) ->
    super
    @updateOrder()

  onRemoveKeyword: (event) =>
    super
    @updateOrder()

  updateOrder: =>
    orderedNames = []
    @$el.find('span.label.keyword').each () ->
      orderedNames.push $(this).attr('id')
    @keywords.updateOrder orderedNames

  getKeywordsAttributes: ->
    @keywords.map (keyword) =>
      name: keyword.get('name')
      id: keyword.get('id')
      _destroy: keyword.get('destroy')
      order: keyword.get('order')
